//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ["xinfo"],
	methods:{
		goBack(){
			history.go(-1);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/rangeDetails/banner.vue